import {Injectable} from "@angular/core";
import {IService} from "../IService";
import {PromotionMessageLayoutModel} from "../../models/promotion-message.model";
import {HttpClientService} from "../httpClient/httpclient.service";

@Injectable()
export class PromotionMessageLayoutService extends IService<PromotionMessageLayoutModel> {

  constructor(
    http: HttpClientService
  ) {
    super(http, 'koncentro-promo', 'message-layout')
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-message-layout.service.ts